import { fetcher } from "helpers/fetcher";

import { TAdHocTicketRes, TCreateAdHocTicketReq } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const createAdHocTicket = async (payload: TCreateAdHocTicketReq) => {
  return await fetcher<TAdHocTicketRes, TCreateAdHocTicketReq["data"]>(
    ENDPOINT.MANAGEMENT.CREATE_AD_HOC_TICKET,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.CREATE_AD_HOC_TICKET.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
    }
  );
};

export const mutationCreateAdHocTicket = async (
  payload: TCreateAdHocTicketReq
) => {
  return (await createAdHocTicket(payload)).data.message;
};

mutationCreateAdHocTicket._key = (payload: TCreateAdHocTicketReq) => [
  ENDPOINT.MANAGEMENT.CREATE_AD_HOC_TICKET.url,
  payload,
];
